

























































import { mapActions, mapGetters } from 'vuex'
import { login, logout } from '@/services/auth'
import { fetchCurrentUser, hasAcceptedTermsConditions } from '@/services/user'
import { MarketplaceFilters } from '@/services/models/marketplace-service-model'
import { User } from '@/services/models/user-service-model'
import { navigateTo } from '@/router'
import { isNetworkError } from '@/custom-errors'
import PublicPageContent from '@/components/PublicPageContent.vue'
import { isWronglyFormattedEmail } from '../email-validations'
import TermsAndConditions from './TermsAndConditions.vue'
import { isPosteTheme } from '@/components/RenderWithTheme.vue'
import WithThemeTitle from '@/components/WithThemeTitle.vue'

const NO_ORCAS_ACCESS_ERROR = 'No orcas access'

export default {
  components: { WithThemeTitle, PublicPageContent, TermsAndConditions },
  data() {
    return {
      username: '',
      email: '',
      showTermsConditions: false,
      password: '',
      errorMessage: null,
      passwordHidden: true,
      loginInProgress: false,
      emailValidators: [
        {
          isInvalid: value => !value,
          errorMessage: this.$t('logIn.noEmailError')
        },
        {
          isInvalid: value => value && isWronglyFormattedEmail(value),
          errorMessage: this.$t('logIn.wrongEmailFormatError')
        }
      ],
      passwordValidators: [
        {
          isInvalid: value => !value,
          errorMessage: this.$t('logIn.noPasswordError')
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['hasOrcasAccess']),
    isPosteTheme() {
      return isPosteTheme
    }
  },
  created() {
    window.addEventListener(
      'beforeunload',
      () => {
        if (this.$router.currentRoute.path.includes('/login')) {
          logout()
        }
      },
      false
    )
  },

  methods: {
    ...mapActions(['resetStore', 'fetchUserHasOrcasAccess', 'fetchCurrentUser']),
    modalClosed(isModalOpen) {
      this.showTermsConditions = isModalOpen
    },
    togglePasswordVisibility() {
      this.passwordHidden = !this.passwordHidden
    },
    handleError(error) {
      if (isNetworkError(error)) navigateTo('/will-be-back')
      if (error.message === NO_ORCAS_ACCESS_ERROR)
        this.errorMessage = 'logIn.noOrcasAccessError'
      else this.errorMessage = 'logIn.wrongCredentialsError'
    },
    buildQueryString(queryParams: MarketplaceFilters): string {
      const queryParamsObj = queryParams || {}
      return Object.entries(queryParamsObj).reduce((accumulator, [param, value]) => {
        const normalizedValue = encodeURIComponent(value)
        return `${accumulator}&${param}=${normalizedValue}`
      }, '')
    },
    async initiateLogin(event) {
      this.errorMessage = ''
      if (event.hasErrors) return

      this.loginInProgress = true
      try {
        await login({ email: this.email, password: this.password })
        await this.fetchCurrentUser()
        await this.verifyUserHasOrcasAccess()
        await this.checkTermsAndCondition()
      } catch (error) {
        this.loginInProgress = false
        return this.handleError(error)
      }
    },
    async fetchCurrentUser() {
      const currentUser: User = await fetchCurrentUser()
      this.username = currentUser?.fullNameWithoutTitle
    },
    async checkTermsAndCondition() {
      const userHasAcceptedTermsAndConditions = await hasAcceptedTermsConditions()
      if (userHasAcceptedTermsAndConditions) {
        this.initiateLoginRedirect()
      } else {
        this.showTermsConditions = true
      }
    },
    async verifyUserHasOrcasAccess() {
      await this.fetchUserHasOrcasAccess()
      if (!this.hasOrcasAccess) {
        await logout()
        this.resetStore()
        throw new Error(NO_ORCAS_ACCESS_ERROR)
      }
    },
    async initiateLoginRedirect() {
      const route = this.$route
      if (!route.query?.redirect) return navigateTo('/')

      const { redirect, ...queryParams } = route.query
      const queryString = this.buildQueryString(queryParams)

      navigateTo(`${redirect}?${queryString}`)
    }
  }
}
